var map = {
	"./AmiyaBagchi.jpg": 619,
	"./AmiyaBagchi.png": 620,
	"./ChinmayTumbe.png": 621,
	"./DavidArnold.jpg": 622,
	"./DavidArnold.png": 623,
	"./DouglasHaynes.jpg": 624,
	"./DouglasHaynes.png": 625,
	"./DwijendraTripathi.jpg": 626,
	"./DwijendraTripathi.png": 627,
	"./GeoffreyJones.png": 628,
	"./IndiraChowdhury.jpg": 629,
	"./IndiraChowdhury.png": 630,
	"./JosephSassoon.jpg": 631,
	"./JosephSassoon.png": 632,
	"./MedhaKudaisya.jpg": 633,
	"./MedhaKudaisya.png": 634,
	"./MilanBalaban.png": 635,
	"./PrafullAnubhai.jpg": 636,
	"./PrafullAnubhai.png": 637,
	"./RamachandraGuha.png": 638,
	"./RituBirla.jpg": 639,
	"./RituBirla.png": 640,
	"./RobertPerks.png": 641,
	"./RossBassett.jpg": 642,
	"./RossBassett.png": 643,
	"./SusiePak.png": 644,
	"./SvenBeckert.png": 645,
	"./SvenBeckertOld.png": 646,
	"./TirthankarRoy.jpg": 647,
	"./TirthankarRoy.png": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;